<template>
<div class="chapter">
<div class="inner_page">
<div class="contentsPage" id="d7e98">
<h3 class="toc" id="d7e99">Contents</h3>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c1#c1">Acknowledgments</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c2#c2">Introduction: A Book Is Born</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#c3">
<b>Chapter One: The First Month</b>
</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s1">Choosing an O.B.</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s2">The No-No List</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s3">Sore Boobs</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s4">Morning, Noon, and Night Sickness</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s5">Gas!</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s6">Resentment Toward Your Hubby</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s7">Tests, Tests, and More Tests</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s8">Dreams and Other Nightmares</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s9">To Tell or Not to Tell</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s10">Pregnancy Math</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Kime_9781440501951_epub_c3#s11">How to Eat for Two</a>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#c4" title="Link target outside of Sample">
<b>Chapter Two: The Second Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s12" title="Link target outside of Sample">Hell Hath No Fury Like a Woman with Child</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s13" title="Link target outside of Sample">Your Superhero Nose</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s14" title="Link target outside of Sample">Pregnancy Junkie</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s15" title="Link target outside of Sample">Spotting</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s16" title="Link target outside of Sample">I Need to Lie Down</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s17" title="Link target outside of Sample">Oh My Achin' Head</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s18" title="Link target outside of Sample">“Urine” for Fun</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s19" title="Link target outside of Sample">Miscarriage</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c4#s20" title="Link target outside of Sample">Sex During the First Trimester</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#c5" title="Link target outside of Sample">
<b>Chapter Three: The Third Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s21" title="Link target outside of Sample">I Can't Breathe!</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s22" title="Link target outside of Sample">Is My Baby Okay in There?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s23" title="Link target outside of Sample">Here I Grow Again</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s24" title="Link target outside of Sample">A New Wardrobe</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s25" title="Link target outside of Sample">The Name Game</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s26" title="Link target outside of Sample">Your Newfound Celebrity</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s27" title="Link target outside of Sample">Drooling</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s28" title="Link target outside of Sample">My Bloody Nose</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c5#s29" title="Link target outside of Sample">Beware of Your Nipples</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#c6" title="Link target outside of Sample">
<b>Chapter Four: The Fourth Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s30" title="Link target outside of Sample">Hyperemesis</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s31" title="Link target outside of Sample">Sex During the Second Trimester</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s32" title="Link target outside of Sample">The Ultrasound</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s33" title="Link target outside of Sample">I'm Scared!</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s34" title="Link target outside of Sample">Vaginal Discharge</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s35" title="Link target outside of Sample">Toilet Troubles</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s36" title="Link target outside of Sample">Bloody Gums</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s37" title="Link target outside of Sample">Genetic Testing</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c6#s38" title="Link target outside of Sample">Boy or Girl?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#c7" title="Link target outside of Sample">
<b>Chapter Five: The Fifth Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s39" title="Link target outside of Sample">Pains Under Your Uterus</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s40" title="Link target outside of Sample">Your Cheesy Belly</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s41" title="Link target outside of Sample">You're So Vein</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s42" title="Link target outside of Sample">Who Asked You?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s43" title="Link target outside of Sample">Third Nipples and Other Gross Things</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s44" title="Link target outside of Sample">That's a Hormone of a Different Color</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s45" title="Link target outside of Sample">Backaches</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c7#s46" title="Link target outside of Sample">Sciatica</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#c8" title="Link target outside of Sample">
<b>Chapter Six: The Sixth Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s47" title="Link target outside of Sample">Dark Back Hair and Other Icky Things</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s48" title="Link target outside of Sample">Leg Cramps</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s49" title="Link target outside of Sample">Belly Touching</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s50" title="Link target outside of Sample">An Itchy Stomach</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s51" title="Link target outside of Sample">Incompetent Cervix</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s52" title="Link target outside of Sample">What, Me Exercise?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s53" title="Link target outside of Sample">Oops, There She Goes!</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c8#s54" title="Link target outside of Sample">Pains in the Tucchus</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#c9" title="Link target outside of Sample">
<b>Chapter Seven: The Seventh Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s55" title="Link target outside of Sample">Swelling Ain't Swell</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s56" title="Link target outside of Sample">Temporary Insanity</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s57" title="Link target outside of Sample">Sex During the Third Trimester</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s58" title="Link target outside of Sample">Toxemia: The Pressure Is On</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s59" title="Link target outside of Sample">Third-Trimester Bleeding</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s60" title="Link target outside of Sample">Braxton Hicks</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s61" title="Link target outside of Sample">I Can't Sleep</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s62" title="Link target outside of Sample">Gestational Diabetes</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c9#s63" title="Link target outside of Sample">Bed Rest</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#c10" title="Link target outside of Sample">
<b>Chapter Eight: The Eighth Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s64" title="Link target outside of Sample">Feeling Hot, Hot, Hot</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s65" title="Link target outside of Sample">Yeast Infections</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s66" title="Link target outside of Sample">Stretched to Extremes</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s67" title="Link target outside of Sample">Heartburn</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s68" title="Link target outside of Sample">“Urine” For Even More Fun</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s69" title="Link target outside of Sample">Incontinence: A Condition That's Sure to Piss You Off</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s70" title="Link target outside of Sample">Numb and Number</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s71" title="Link target outside of Sample">Stop That Kicking!</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s72" title="Link target outside of Sample">How the Hell Is This Thing Coming Out?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c10#s73" title="Link target outside of Sample">Don't Breech to Me</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#c11" title="Link target outside of Sample">
<b>Chapter Nine: The Ninth Month</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s74" title="Link target outside of Sample">Baby Shower 101</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s75" title="Link target outside of Sample">Nesting Instinct</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s76" title="Link target outside of Sample">Lamaze Class</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s77" title="Link target outside of Sample">Nursing Bras</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s78" title="Link target outside of Sample">Decorating the Baby's Room</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s79" title="Link target outside of Sample">Taking a Tour of the Hospital</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s80" title="Link target outside of Sample">Am I in Labor?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s81" title="Link target outside of Sample">False Labor</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c11#s82" title="Link target outside of Sample">How to Start Labor</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#c12" title="Link target outside of Sample">
<b>Chapter Ten: Let the Bloody Show Begin</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s83" title="Link target outside of Sample">Inducing</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s84" title="Link target outside of Sample">“Lookie Loos”</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s85" title="Link target outside of Sample">How to Breathe Through a Contraction</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s86" title="Link target outside of Sample">Gimme Drugs</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s87" title="Link target outside of Sample">How to Push with a Passion</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s88" title="Link target outside of Sample">Episiotomy: Let 'er Rip</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s89" title="Link target outside of Sample">The “C” Word</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s90" title="Link target outside of Sample">Bonding</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s91" title="Link target outside of Sample">What to Do When Nature Calls</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s92" title="Link target outside of Sample">Lochia: Who Knew?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c12#s93" title="Link target outside of Sample">Got Milk?</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#c13" title="Link target outside of Sample">
<b>Chapter Eleven: Home, Bittersweet Home</b>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s94" title="Link target outside of Sample">Baby Blues</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s95" title="Link target outside of Sample">How to Deal with Visitors</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s96" title="Link target outside of Sample">Better Sleep for You and Your Baby</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s97" title="Link target outside of Sample">Baby Hygiene</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s98" title="Link target outside of Sample">Sex after the Last Trimester</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s99" title="Link target outside of Sample">Sleep Deprivation</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s100" title="Link target outside of Sample">Muscle Soreness</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s101" title="Link target outside of Sample">Reconcilable Differences</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s102" title="Link target outside of Sample">How to Deal with a Crying Baby</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s103" title="Link target outside of Sample">The Basics</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c13#s104" title="Link target outside of Sample">About the Third Month</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Kime_9781440501951_epub_c14#c14" title="Link target outside of Sample">Appendix: Resources List</span>
<br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Kime_9781440501951_epub_toc.vue?9c373898